import storageService from './storageService'

export { StorageService } from './storageService'

export default storageService
